module.exports = __webpack_public_path__ + "static/media/chip_500.ff436a1d.png";